import {
  QueryCondition,
  QueryOperation,
  SearchQuery,
} from "../code/search-query/search-query";
import { DataColumn } from "../controls/Data.default";
import { nameOf } from "../utils/typescript";
import _ from "lodash";
import { hasValue } from "../utils/string";
import { InputObject } from "../controls/default";

export interface DepartmentsViewForm {
  readonly name: string;
}

export const departmentsViewColumns: DataColumn[] = [
  {
    title: "Name",
    key: "name",
    width: 192,
    sort: true,
        fixed: 'left'
  },
];

export function mapDepartmentsViewQuery(
  values: DepartmentsViewForm,
): SearchQuery {
  const conditions: QueryCondition[] = Object.entries(values)
        .filter(([key, value]) =>
      hasValue(value),
    )
    .map(([key, value]) => {
      switch (key) {
        case nameOf<DepartmentsViewForm>("name"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
      }
    })
    .filter((f) => !!f) as QueryCondition[];

  return {
    conditions,
  };
}
